<div class="stdTheme" style="overflow-x: hidden; overflow-y: hidden;">
    <div *ngFor="let item of dataList;let i = index;" style="overflow-x: hidden; overflow-y: hidden;">
        <div id="rubric_{{i}}" #rubric_{{i}} class="row taskrubrics"
                [ngClass]="{'taskrubrics': !item.isSelected,'taskrubricsSelected': item.isSelected}"
                > 
            <div class="col-1">
                <button  mat-icon-button (click)="item.isCollapsed = !item.isCollapsed; collapsedOther(i, item.isCollapsed) ">
                    <span *ngIf="item.isCollapsed"  >
                        <i class="fa fa-chevron-down" style="font-size: 15px"></i>
                    </span>
                    <span *ngIf="!item.isCollapsed" >
                        <i class="fa fa-chevron-up" style="font-size: 15px"></i>
                    </span>
                </button> 
            </div>
            <div class="col-11" style="margin: 0px;text-align: start;">
                <a *ngIf="item.childProperties[0].propertyLength === 0"  style="margin: 0px;">{{item.parentName}}             
                </a>
                <a *ngIf="item.childProperties[0].propertyLength !== 0"  style="margin: 0px;"><b>
                    {{item.parentName}} ({{item.childProperties[0].propertyLength}})</b>             
                </a>
                <a *ngIf="item.parentTech === 'works' && (item.childProperties[0].duration) && (item.childProperties[0].duration >0)">
                    {{ 'totalDuration' | translate }} : {{item.childProperties[0].duration}}
                </a>
            </div>
        </div>
        
        <div [ngbCollapse]="item.isCollapsed">
            <mdi-taskref-actions style="width: 100%" 
                [optionItem]="item.parentTech" 
                [ihmOptions]="ihmOptions"
                [actionType]="actionType" 
                [wksEntity]="wksEntity"
                [parentTask]="parentTask"
                [parentParam]="item.childProperties[0].propertyContent.parentParam"
                [rowTask]="rowTask"
                (dataOut)="statutCur($event)"
                >
            </mdi-taskref-actions>
        </div>
        <div class="lineWks" style="margin-top: 5px;"></div>
    </div>
</div>
